<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$moment.locale("th");
    this.getTheme();
  },
  methods: {
    invertColor(hex, bw) {
      if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
      }

      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
      }
      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);

      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    },
    async getTheme() {
      const theme = await this.axios(`${this.$baseUrl}/customer/theme`);

      this.$store.dispatch("setColorPrimary", theme.themePrimaryColor);
      this.$store.dispatch("setColorSecondary", theme.themeSecondaryColor);

      this.$store.dispatch(
        "setBackgroundPrimary",
        `background-color: ${theme.themePrimaryColor}`
      );
      // }
      this.$store.dispatch(
        "setBackgroundSecondary",
        `background-color: ${theme.themeSecondaryColor}`
      );
      // console.log( this.$baseTheme);
      this.$store.dispatch(
        "setLoGoHomePage",
        this.$baseTheme + theme.themeLogoLoginPage
      );
      // },
      const data = theme;
      let bodyStyles = document.body.style;
      bodyStyles.setProperty("--primary-color", data.themePrimaryColor);
      bodyStyles.setProperty("--secondary-color", data.themeSecondaryColor);
      bodyStyles.setProperty(
        "--font-color",
        this.invertColor(data.themeSecondaryColor, true)
      );
      bodyStyles.setProperty(
        "--font-primary-color",
        this.invertColor(data.themePrimaryColor, true)
      );
      bodyStyles.setProperty("--font-disable-color", data.themeDisableColor);
      bodyStyles.setProperty(
        "--font-disable-color",
        this.invertColor(data.themeDisableColor, true)
      );
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
